/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Liveroomfunnelscans3Inputs */

const en_liveroomfunnelscans3 = /** @type {(inputs: Liveroomfunnelscans3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code opened`)
};

const de_liveroomfunnelscans3 = /** @type {(inputs: Liveroomfunnelscans3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code geöffnet`)
};

/**
* | output |
* | --- |
* | "Code opened" |
*
* @param {Liveroomfunnelscans3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const liveroomfunnelscans3 = /** @type {((inputs?: Liveroomfunnelscans3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Liveroomfunnelscans3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_liveroomfunnelscans3(inputs)
	return de_liveroomfunnelscans3(inputs)
});
export { liveroomfunnelscans3 as "liveRoomFunnelScans" }